/** @format */
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { OIB } from "../../Config/Regex";
import { migrationServices } from "../../Services/migration.services";

const Add = ({ onSuccess, setResultModal, disabled }) => {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit = (data) => {
    migrationServices
      .create(data.oib)
      .then((res) => {
        onSuccess();
        setResultModal({
          show: true,
          title: res.data.success
            ? translator("CardTypes-AddCardType-SuccesModal-Title")
            : "Greška",
          text: translator(res.data.message),
          btnClass: "btn btn-primary",
        });
      })
      .catch((err) => console.log(err));
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="p-4"
      style={{ border: "1px solid lightgray" }}
    >
      <h5 className="mb-4 text-center font-weight-bold">
        {translator("Migration-Overview")}
      </h5>

      <fieldset className="scheduler-border">
        <div className="form-group">
          <label>{translator("OIB")}</label>
          <input
            type="text"
            className="form-control"
            ref={register({
              required: true,
              pattern: OIB,
            })}
            name="oib"
            disabled={disabled}
          />
          {errors.name && errors.name.type === "required" && (
            <p className="text-danger">
              {translator("ValidationMsg-RequiredField")}
            </p>
          )}
          {errors.name && errors.name.type === "pattern" && (
            <p className="text-danger">
              {translator("ValidationMsg-LettersOnly")}
            </p>
          )}
          {errors.name && errors.name.type === "maxLength" && (
            <p className="text-danger">
              {translator("ValidationMsg-MaxLength11")}
            </p>
          )}
        </div>
      </fieldset>

      <div className="d-flex justify-content-end mt-2">
        <button className="btn btn-primary" type="submit" disabled={disabled}>
          {translator("Btn-Save")}
        </button>
      </div>
    </form>
    // </Modal>
  );
};

export default Add;
